import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="10" height="71" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1.092 70.205V.5h7.497v69.705H1.092z" stroke="#000" /></svg>;